import { Card } from '@/components/ui';
import { Container, Grid, Skeleton, Stack, VStack } from '@chakra-ui/react';
import React from 'react';

/**
 * Skeleton loader for subscription page
 * Displays loading placeholders while subscription data is being fetched
 */
const SubscriptionPageSkeleton: React.FC = () => {
  return (
    <Container maxW="1100px" width="full" padding={6}>
      <VStack w="full" gap={6} align="stretch">
        {/* Page header skeleton */}
        <VStack align="stretch" gap={2}>
          <Skeleton height="32px" width="200px" />
          <Skeleton height="20px" width="400px" />
        </VStack>

        {/* Main card skeleton */}
        <Card.Root w="full">
          <Card.Body>
            <VStack gap={8} align="stretch">
              {/* Current Plan Section */}
              <Grid
                templateColumns={{ base: '1fr', lg: '300px 1fr' }}
                gap={{ base: 6, lg: 8 }}
                w="full"
              >
                {/* Left Column: Title, Description, Action */}
                <VStack align="stretch" gap={3}>
                  <VStack gapY={2} align="flex-start">
                    <Skeleton height="28px" width="150px" />
                    <Skeleton height="20px" width="250px" />
                  </VStack>
                  <Skeleton height="36px" width="120px" />
                </VStack>

                {/* Right Column: Plan Details Card */}
                <Card.Root>
                  <Card.Body>
                    <Stack gap={3}>
                      <Skeleton height="24px" width="140px" />
                      <Skeleton height="20px" width="100px" />
                      <Skeleton height="18px" width="200px" />
                    </Stack>
                  </Card.Body>
                </Card.Root>
              </Grid>
            </VStack>
          </Card.Body>
        </Card.Root>
      </VStack>
    </Container>
  );
};

export default SubscriptionPageSkeleton;
